import {create as zustandCreate} from "zustand";
import {immer} from "zustand/middleware/immer";
import type {MaybeNil, ZodProperties} from "app/utils/types";
import {CompleteStatus, ControlCardCategory, type LocationControlCardDeckInputV2Input} from "app/gql/graphqlSchema";
import {z} from "zod";
import {zControlCardTemplateId, zLocalDate, zLocationId, zNormalizedStringToNull, zToNull} from "app/utils/validator";

export const zControlCardCategory = z.nativeEnum(ControlCardCategory);
export const zCompleteStatus = z.nativeEnum(CompleteStatus);

type LocationControlCardFilterInput = Pick<
  LocationControlCardDeckInputV2Input,
  "category" | "dailyDate" | "recurringDateRange" | "recurringTemplateIds" | "completeStatus" | "query" | "locationId"
>;

export const locationControlCardFilterSchema = z.object<ZodProperties<LocationControlCardFilterInput>>({
  locationId: zLocationId,
  category: zControlCardCategory,
  dailyDate: zLocalDate,
  recurringDateRange: z.object<ZodProperties<LocationControlCardFilterInput["recurringDateRange"]>>({
    start: zLocalDate,
    end: zLocalDate
  }),
  completeStatus: zCompleteStatus,
  query: zToNull.or(zNormalizedStringToNull),
  recurringTemplateIds: z.array(zControlCardTemplateId)
});

export type LocationControlCardFilter = z.infer<typeof locationControlCardFilterSchema>;

type LocationControlCardGlobalFilterStore = {
  filter: MaybeNil<LocationControlCardFilter>;
};

export const useLocationControlCardGlobalFilter = zustandCreate(
  immer<LocationControlCardGlobalFilterStore>(() => ({
    filter: null
  }))
);
